module.exports = __webpack_public_path__ + "static/media/burundi.d18a55a7.jpg";